import React, { useState, useCallback, useEffect } from "react";
import Cover from "../Cover";
import BoxContainer from "../BoxContainer";
import BoxRaised from "../BoxRaised";
import { useMediaQuery, useTheme, Box } from "@material-ui/core";
import { useStyles, useLoadingIndicatorContext } from "../../hooks";
import styles from "./styles";
import { requestWithAuthApiManager, requestValidarToken, requestGetDetail } from "../../api";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { getDeviceId, getBrowser } from '../../utils';
import { setDataSteep } from "../../redux/actions/hireActions";
import { infoProvinces, infoProducts } from '../../data';
import { PUBLICURL } from "../../main_config";
import IconBackground from "../IconBackground";
import Hidden from "@material-ui/core/Hidden";
import {
  TrainingCourses as TrainingCoursesIcon,
  PersonalPhysician as PersonalPhysicianIcon
} from "../Icons";
import SectionOurProducts from "../SectionOurProducts";
import ModalSmg from "../Modal";
import DialogContentSmg from "../DialogContentSmg";
import TokenExpiration from "./TokenExpiration";

const ProductInit = () => {
    const classes = useStyles(styles);
    const theme = useTheme();
    const matchesUpLG = useMediaQuery(theme.breakpoints.up("lg"));
    const matches = useMediaQuery(theme.breakpoints.up("xs"));
    const { setLoading } = useLoadingIndicatorContext(); 
    const [errorToken, setErrorToken] = useState(false)
    const [openModalError, setOpenModalError] = useState(false);
    const handleCloseModalError = useCallback(() => setOpenModalError(false), []);
    const history = useHistory();
    const dispatch = useDispatch();
    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    const queryToken = queryParams.get('token');
    const queryTramite = queryParams.get('numTramite');
    const queryDni = queryParams.get('dni');
    const origen = queryParams.get('origen');
    const esChatbotOrigen = origen === 'chatbot';
    const [messageError, setMessageError] = useState('');

 const requestObtenerDetalle = async (values) => {
    setLoading(true)
        try {
          const response = await requestWithAuthApiManager(values.recaptcha, {
            url: `/api-smg/V1/ecco/venta_online/${queryTramite}/detalle`,
            method: "GET",
            data: {}
          });
           if (response.status === 200 && (response.data.nombrePro !== null && response.data.nombrePro !== undefined)) {
             
           
                const provinceValue = infoProvinces.find(f => f.provId === response.data.provinciaId);
              let data = { 
                    formData: { 
                        firstName: response.data.nombrePro,
                        lastName : response.data.apellidoPro,
                        documentType: response.data.tipoDoc,
                        documentNumber : queryDni,
                        email: response.data.email,
                        areaCode : response.data.telCodigoNacional,
                        phoneNumber: response.data.telefono,
                        sex : response.data.sexo,
                        product: "1",
                        province : provinceValue.value,
                        locality: response.data.locality,
                        recaptcha : "",
                        qtyMembers: response.data.cantIntegrantes,
                        price: parseInt(response.data.valorTotal),
                        domicilio: {
                            provincia: response.data.provincia.toUpperCase(),
                            partido: response.data.partido.toUpperCase(),
                            localidad: response.data.localidad.toUpperCase(),
                            provinciaId: response.data.provinciaId,
                            localidadId: response.data.localidadId,
                            partidoId: response.data.partidoId,
                        },
                        response:{
                          tramite: {
                              jbpmProcess: parseInt(queryTramite),
                              mapBodyResponseBundleEspecifico: {
                                      credencial: response.data.credencial,
                                      idProspecto: response.data.idProspecto
                              }
                          },
                          cotizacion: {
                              totalCBU: parseInt(response.data.valorTotal)
                          }
                      },
                    },
                    response:{
                        tramite: {
                            jbpmProcess: parseInt(queryTramite),
                            mapBodyResponseBundleEspecifico: {
                                    credencial: response.data.credencial,
                                    idProspecto: response.data.idProspecto
                            }
                        },
                        cotizacion: {
                            totalCBU: response.data.valorTotal
                        }
                    },
                    localities: provinceValue.onlyThisLocalities,
                    idLocality: response.data.locality,
                }
                
               dispatch(setDataSteep({ steep: 1,actualSteep:2, data }));
               dispatch(setDataSteep({ steep: 2,actualSteep:3, data }));
               setTimeout(() => {          
                history.push("/productos/contratar/datosintegrantes"); 
              }, 2000);            
           }else{
             setLoading(false);
             if (esChatbotOrigen){
                setMessageError("¡Lo sentimos! El link para completar el trámite ha caducado. Te invitamos a regresar al chatbot y hablar con un asesor para obtener más información.\nMuchas gracias");
             } else {
                setMessageError("El link para completar el trámite ha caducado. Ya existe un trámite para el documento ingresado. Un asesor comercial se estará contactando a la brevedad.\nMuchas gracias");
             }
             setOpenModalError(true)
           }
            setLoading(false);
    } catch (error) {
      setLoading(false);
      if (esChatbotOrigen){
        setMessageError("¡Ups! Algo salió mal con el proceso. Por favor, inténtalo más tarde o vuelve al chatbot para recibir ayuda.\nMuchas gracias");
      } else {
        setMessageError("Ocurrió un inconveniente en el proceso, intente más tarde");
      }
      setOpenModalError(true)
    }
  }; 

   useEffect(()=> {
    if(queryTramite === "" || queryTramite === null || queryToken === ""  || queryToken === null || queryDni === "" || queryDni === null){
      setTimeout(() => {          
        history.push("/productos/consulta"); 
      }, 1000); 
    } else {
      setLoading(true);
      const tokenReplace = queryToken.replace(/ /g, "+")
      requestValidarToken(tokenReplace, { data: 
        {
          "device": {           
            "bloqueado"  : true,
            "recordar"   : true,
            "deviceid":  getDeviceId(),
            "messagingid": "----",
            "devicename": getBrowser()
      
          }
        }}).then(response => {
            if (response && response.status === 200) {
               requestGetDetail(response.data.token, queryTramite).then(responseDetail => {
                  if (responseDetail) {
                    const provinceValue = infoProvinces.find(f => f.provId === responseDetail.provinciaId);
                    let data = { 
                          formData: { 
                              firstName: responseDetail.nombrePro,
                              lastName : responseDetail.apellidoPro,
                              documentType: responseDetail.tipoDoc,
                              documentNumber : queryDni,
                              email: responseDetail.email,
                              areaCode : responseDetail.telCodigoNacional,
                              phoneNumber: responseDetail.telefono,
                              sex : responseDetail.sexo,
                              product: "1",
                              province : provinceValue.value,
                              locality: responseDetail.locality,
                              recaptcha : "",
                              qtyMembers: responseDetail.cantIntegrantes,
                              price: parseInt(responseDetail.valorTotal),
                              domicilio: {
                                  provincia: responseDetail.provincia.toUpperCase(),
                                  partido: responseDetail.partido.toUpperCase(),
                                  localidad: responseDetail.localidad.toUpperCase(),
                                  provinciaId: responseDetail.provinciaId,
                                  localidadId: responseDetail.localidadId,
                                  partidoId: responseDetail.partidoId,
                              },
                              response:{
                                tramite: {
                                    jbpmProcess: parseInt(queryTramite),
                                    mapBodyResponseBundleEspecifico: {
                                            credencial: responseDetail.credencial,
                                            idProspecto: responseDetail.idProspecto
                                    }
                                },
                                cotizacion: {
                                    totalCBU: parseInt(responseDetail.valorTotal)
                                }
                            },
                          },
                          response:{
                              tramite: {
                                  jbpmProcess: parseInt(queryTramite),
                                  mapBodyResponseBundleEspecifico: {
                                          credencial: responseDetail.credencial,
                                          idProspecto: responseDetail.idProspecto
                                  }
                              },
                              cotizacion: {
                                  totalCBU: responseDetail.valorTotal
                              }
                          },
                          localities: provinceValue.onlyThisLocalities,
                          idLocality: responseDetail.locality,
                      }
                      dispatch(setDataSteep({ steep: 1,actualSteep:2, data }));
                      dispatch(setDataSteep({ steep: 2,actualSteep:3, data }));
                      setTimeout(() => { 
                        setLoading(false);     
                        history.push("/productos/contratar/datosintegrantes"); 
                      }, 1000);
                  }
                  }).catch(e => {
                      setLoading(false);
                      setErrorToken(true)
                    })
                  }}).catch(e => {
                    setLoading(false);
                    setErrorToken(true)
                  })
              }
   },[]) 

  return (
    <>
{matches ?
        <Box>
          <Cover
            pathImage={`${PUBLICURL}/assets/images/slider-ambulancia.png`}
            root2
          />
          <BoxContainer>
            <BoxRaised root2 maxWidth={matchesUpLG ? 633 : 500}>
              <TokenExpiration
                requestObtenerDetalle={requestObtenerDetalle}
                errorToken={errorToken}

              ></TokenExpiration>
            </BoxRaised>
            <Hidden only={["xs", "sm", "md"]}>
              <IconBackground
                icon={TrainingCoursesIcon}
              />
              <IconBackground
                icon={PersonalPhysicianIcon}
                root2
              />
            </Hidden>
          </BoxContainer>
          <SectionOurProducts listCards={infoProducts} /> </Box> :
        <Box>
          <Box className={classes.wrappedForm}  >
          <TokenExpiration
           requestObtenerDetalle={requestObtenerDetalle}
           errorToken={errorToken}
          ></TokenExpiration>
          </Box>
          <SectionOurProducts listCards={infoProducts} />
        </Box>}
        <ModalSmg
        id="error-products-init"
        open={openModalError}
        ButtonsProps={[
          {
            id: "btn-confirm-modal-error-products-init",
            color: "primary",
            content: "Aceptar",
            onClick: handleCloseModalError
          }
        ]}
      >
        <DialogContentSmg 
          title="¡Lo sentimos!" 
          message={messageError} 
          style={{ 
            textAlign: "center",
            whiteSpace: "pre-line",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        />
      </ModalSmg>
    </>
  );
};


export default ProductInit;